import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { NextStep } from '../common/nextStep';
import embroideryImage from '../../assets/placement.png';
import embroiderySpImage from '../../assets/placement-sp.png';
import { CustomizeContext } from '../contexts/customize';

const baseURL = process.env.REACT_APP_API_URL;
const client = axios.create({
  baseURL
});

const MtmEmbroidery = ({ pocketData, placketData }) => {
  const [color, setColor] = useState();
  const [font, setFont] = useState();
  const [format, setFormat] = useState();
  const [placement, setPlacement] = useState();
  const [text, setText] = useState();
  const [isEmbroidery, setIsEmbroidery] = useState(false);
  const [selectedColor, setSelectedColor] = useState(false);
  const [selectedFont, setSelectedFont] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState(false);
  const [selectedPlacement, setSelectedPlacement] = useState();
  const [selectedText, setSelectedText] = useState();
  const [message, setMessage] = useState('');

  const { customizes, setCustomizes } = useContext(CustomizeContext);

  useEffect(() => {
    const contextEmbroideryOptions = {
      embroidery: {
        value: isEmbroidery
      },
      embroidery_color: {
        id: selectedColor ? selectedColor.id : '',
        value: selectedColor ? selectedColor.value : '',
        img: selectedColor ? selectedColor.img : ''
      },
      embroidery_type: {
        id: selectedFont ? selectedFont.id : '',
        value: selectedFont ? selectedFont.value : '',
        img: selectedFont ? selectedFont.img : ''
      },
      embroidery_place: {
        id: selectedPlacement ? selectedPlacement.id : '',
        value: selectedPlacement ? selectedPlacement.value : '',
        img: embroideryImage
      },
      embroidery_format: {
        id: selectedFormat ? selectedFormat.id : '',
        value: selectedFormat ? selectedFormat.value : ''
      },
      embroidery_initial: {
        value: selectedText ? selectedText : ''
      }
    };
    setCustomizes({
      ...customizes,
      embroideryOptions: { ...contextEmbroideryOptions }
    });
  }, [
    isEmbroidery,
    selectedColor,
    selectedFont,
    selectedPlacement,
    selectedFormat,
    selectedText
  ]);

  useEffect(() => {
    axios
      .all([
        axios.get(baseURL + '/get_emb_color_master'),
        axios.get(baseURL + '/get_emb_font_master')
      ])
      .then(
        axios.spread((colors, fonts) => {
          setColor(colors.data.colors);
          setFont(fonts.data.letter_type);
        })
      )
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (placketData) {
      const getPlacement = async () => {
        const pocket = pocketData
          ? '?pocket_id=' + pocketData.id + '&pocket_value=' + pocketData.value
          : false;
        const placement = await client
          .get(
            baseURL +
              '/get_embroidery_positions' +
              (pocket ? pocket + '&' : '?') +
              'placket_id=' +
              placketData.id +
              '&placket_value=' +
              placketData.value
          )
          .catch((error) => {
            console.log(error);
          });
        setPlacement(placement.data.letter_place);
      };
      getPlacement();
    }
  }, [pocketData, placketData]);

  useEffect(() => {
    if (selectedFont) {
      const getFormat = async () => {
        const formats = await client
          .get(
            baseURL +
              '/get_embroidery_letter_formats' +
              '?letter_type=' +
              selectedFont.id
          )
          .catch((error) => {
            console.log(error);
          });
        setFormat(formats.data.letter_format);
      };
      getFormat();
    }
  }, [selectedFont]);

  useEffect(() => {
    if (selectedFormat && selectedFont && selectedPlacement) {
      const getText = async () => {
        const texts = await client
          .get(
            baseURL +
              '/get_embroidery_letters' +
              '?letter_format=' +
              selectedFormat.id +
              '&letter_type=' +
              selectedFont +
              '&letter_place=' +
              selectedPlacement.id
          )
          .catch((error) => {
            console.log(error);
          });
        setText(texts.data.letter_options);
      };
      getText();
    }
  }, [selectedFormat, selectedFont, selectedPlacement]);

  const getOptionId = (select) => {
    const index = select.target.selectedIndex;
    const selectedOption = select.target.childNodes[index];
    return selectedOption.getAttribute('id');
  };

  const handleColor = (e) => {
    setSelectedColor({
      id: e.target.id,
      value: e.target.value,
      img: e.target.closest('div').querySelector('img').src
    });
  };

  const handleFont = (e) => {
    setSelectedFont({
      id: e.target.id,
      value: e.target.value,
      img: e.target.closest('div').querySelector('img').src
    });
  };

  const handleFormat = (e) => {
    setSelectedText('');
    const resetOption = [
      {
        type: 'SELECT',
        max_length: 1, 
        options: [
          {id: 'none', label: '-'}
        ]
      }
    ]
    setText(resetOption);
    setSelectedFormat({
      id: getOptionId(e),
      value: e.target.value
    });
  };

  const handlePlacement = (e) => {
    setMessage('');
    setSelectedPlacement({
      id: getOptionId(e),
      value: e.target.value
    });
  };

  const renderLetterFormat = (option) => {
    const renderSelect = () => {
      return (
        <select className="mtm--row_embroidery--select-font">
          <option hidden value="">
            -
          </option>
          {option.options.map((letter) => {
            return (
              <option id={letter.id} value={letter.value}>
                {letter.label}
              </option>
            );
          })}
        </select>
      );
    };

    if (option.type === 'SELECT') {
      return renderSelect(option);
    } else if (option.type === 'PERIOD') {
      return <span>.</span>;
    } else {
      return (
        <input
          type="text"
          maxLength={option.max_length}
          value={message}
          onChange={formatLetters}
          placeholder="Use only alphabet"
        />
      );
    }
  };

  const getLetterData = (e) => {
    const parent = e.target.closest('div');
    const elements = Array.from(parent.childNodes);
    let data = '';
    elements.map((child) => {
      if (child.nodeName === 'SELECT' || child.nodeName === 'INPUT') {
        data = data + child.value;
      } else {
        data = data + child.innerHTML;
      }
    });
    setSelectedText(data);
  };

  const formatLetters = (e) => {
    const input = e.target.value;
    const capitalized =
      input.charAt(0).toUpperCase() + input.substring(1).toLowerCase();
    const filterLetters = capitalized.replace(/[^a-zA-Z]/gi, '');
    setMessage(filterLetters);
  };

  const iconCheck = (
    <svg
      width="35"
      height="26"
      viewBox="0 0 35 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 12.2L12.5283 23L33 2" stroke="white" strokeWidth="3" />
    </svg>
  );

  return (
    <div className="mtm-item__wrapper" id="mtm-monograms">
      <h3 className="mtm-embroidery__title">MONOGRAMS</h3>
      <div className="row mtm-embroidery-row">
        <div className="mtm-item__sub-title mb-3 text-start">EMBROIDERY</div>
        <input type="radio" id="with" name="embroidery" value="with" hidden />
        <label
          className="mtm--embroidery-select d-flex align-items-center col-12 col-md-4 py-4"
          htmlFor="with"
          onClick={() => {
            setIsEmbroidery(true);
          }}
        >
          <div className="mtm--embroidery-select_checkbox me-3" />
          <span>With Embroidery</span>
        </label>
        <input
          type="radio"
          id="without"
          name="embroidery"
          value="without"
          hidden
        />
        <label
          className="mtm--embroidery-select d-flex align-items-center col-12 col-md-4 py-4"
          htmlFor="without"
          onClick={() => {
            setIsEmbroidery(false);
          }}
        >
          <div className="mtm--embroidery-select_checkbox me-3" />
          <span>Without Embroidery</span>
        </label>
      </div>
      {isEmbroidery && (
        <>
          <h3 className="mtm-item__sub-title mt-5 text-md-left">COLORS</h3>
          <div className="row row-cols-2 row-cols-md-5">
            {color.map((option) => (
              <div className="col">
                <input
                  type="radio"
                  id={option.color_cd}
                  name="colors"
                  value={option.label}
                  hidden
                  onChange={handleColor}
                />
                <label
                  htmlFor={option.color_cd}
                  className="mtm--embroidery-colors"
                >
                  <div className="mtm--embroidery_img-wrapper mb-4">
                    <div className="mtm--embroidery_selected d-flex flex-column align-items-center justify-content-center">
                      {iconCheck}
                      <span className="mt-1">Selected</span>
                    </div>
                    <img className="w-100" src={option.image_url} />
                  </div>
                  <span>{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          <h3 className="mtm-item__sub-title mt-5 text-md-left">FONTS</h3>
          <div className="row row-cols-1 row-cols-md-5">
            {font.map((option) => (
              <div className="col">
                <input
                  type="radio"
                  id={option.id}
                  name="fonts"
                  value={option.label}
                  hidden
                  onChange={handleFont}
                />
                <label htmlFor={option.id} className="mtm--embroidery-colors">
                  <div className="mtm--embroidery_img-wrapper mb-4">
                    <div className="mtm--embroidery_selected d-flex flex-column align-items-center justify-content-center">
                      {iconCheck}
                      <span className="mt-1">Selected</span>
                    </div>
                    <img className="w-100" src={option.image_url} />
                  </div>
                  <span>{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          <h3 className="mtm-item__sub-title mt-5 text-md-left">PLACEMENT</h3>
          <div className="mtm--row_embroidery row">
            <div className="mtm--row_embroidery--wrap col-12 col-md-4">
              <p>Location</p>
              <select
                className="mtm--row_embroidery--select"
                onChange={handlePlacement}
              >
                <option hidden value="">
                  -
                </option>
                {placement !== undefined &&
                  placement.map((option) => (
                    <option value={option.label} id={option.id} key={option.id}>
                      {option.label}
                    </option>
                  ))}
              </select>
              <p>Format</p>
              <select
                className="mtm--row_embroidery--select"
                onChange={handleFormat}
              >
                <option hidden value="">
                  -
                </option>
                {format !== undefined &&
                  format.map((option) => (
                    <option value={option.name} id={option.id} key={option.id}>
                      {option.name}
                    </option>
                  ))}
              </select>
              <p>Text</p>
              {text !== undefined ? (
                <div
                  onChange={getLetterData}
                  className="mtm--row_embroidery--select-wrap d-flex align-items-center p-0"
                >
                  {text.map((option) => renderLetterFormat(option))}
                </div>
              ) : (
                <div className="mtm--row_embroidery--select-wrap d-flex align-items-center p-0">
                  <select className="mtm--row_embroidery--select-font">
                    <option hidden value="">
                      -
                    </option>
                  </select>
                  <span>.</span>
                  <select className="mtm--row_embroidery--select-font">
                    <option hidden value="">
                      -
                    </option>
                  </select>
                  <span>.</span>
                  <select className="mtm--row_embroidery--select-font">
                    <option hidden value="">
                      -
                    </option>
                  </select>
                </div>
              )}
            </div>
            <img
              className="col-7 mtm--row_embroidery--img pc"
              src={embroideryImage}
              alt="mtm-embroidery"
            />
            <img
              className="w-100 mtm--row_embroidery--img sp"
              src={embroiderySpImage}
              alt="mtm-embroidery"
            />
          </div>
        </>
      )}
      <NextStep />
    </div>
  );
};

export default MtmEmbroidery;
